import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { toDatabaseValue } from "@/utils/supabase/type-guards";

export const usePromptReport = (promptId: string, user: any) => {
  const [isReportDialogOpen, setIsReportDialogOpen] = useState(false);
  const [isReporting, setIsReporting] = useState(false);

  const handleReport = async (reason: string) => {
    if (!user) {
      toast.error("You must be signed in to report a prompt");
      return;
    }
    
    setIsReporting(true);
    try {
      const { error } = await supabase
        .from('reported_prompts')
        .insert([{
          prompt_id: toDatabaseValue(promptId),
          reported_by: toDatabaseValue(user.id),
          reason: reason
        }]);
      
      if (error) throw error;
      
      toast.success("Prompt reported successfully");
      setIsReportDialogOpen(false);
    } catch (error: any) {
      console.error('Error reporting prompt:', error);
      
      // Check if it's a duplicate report
      if (error.code === '23505') {
        toast.error("You have already reported this prompt");
      } else {
        toast.error(error.message || "Failed to report prompt");
      }
    } finally {
      setIsReporting(false);
    }
  };

  return {
    isReportDialogOpen,
    isReporting,
    setIsReportDialogOpen,
    handleReport
  };
};